import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSonarlintComponent } from './simple-icons-sonarlint.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSonarlintComponent ],
    exports:      [ SimpleIconsSonarlintComponent ],
    bootstrap:    []
})
export class SimpleIconsSonarlintModule {}
